import React from 'react'

// https://github.com/reach/router/issues/242#issuecomment-491537468
const ScrollToTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname])
  return children
}

export default ScrollToTop
